import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {compose} from 'redux';
import AppButton from '../../../components/app-button';
import {Column, Row} from '../../../components/layout';
import {setWizard} from '../../../store/actions';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import BubbleMedicoOnline from '../../services/bubble-medico-online';
import './styles.scss';
import AuthorizedImage from '../../../components/images';
import {get} from '../../../api/api';
import {
  uriGetAppointmentsUpcoming,
  uriGetUserConsents,
  uriUserBuOnlineOnly,
} from '../../../api/endpoints';
import AppointmentsPermissions from '../../appointments/components/appointments-permissions-popup/AppointmentsPermissions';
import AppointmentsScheduleCapPopup from '../../appointments/components/appointments-schedule-cap-popup/AppointmentsScheduleCapPopup';
import ModalTemplate from '../../../components/modal';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';

// ir buscar strings ao BO
const labels = strings.pt.services;
interface MedicoOnlineProps {
  user: any;
  selectedBu?: any;
  availableBus?: any;
  wizard?: any;
  buStyles: any;
  setWizard(value: any): void;
  labels?: typeof strings.pt.services;
  appointmentsLabels: typeof strings.pt.appointments;
  medicoOnline: any;
  medicoOnlineDisabled: boolean;
  visible?: boolean;
  busFuncMapDefault: any;
  labelsOneTrust: any;
}
enum Bu {
  notClient = 'NOTCLIENT',
}

function MedicoOnline({
  user,
  medicoOnline,
  medicoOnlineDisabled,
  appointmentsLabels,
  visible = true,
  busFuncMapDefault,
  labelsOneTrust,
  selectedBu,
}: MedicoOnlineProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [patientList, setPatientList] = useState<any>([{}]);
  const [patientListSet, setPatientListSet] = useState(false);
  const [showError, setShowError] = useState(false);
  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.oneTrust],
  );
  const [termsMain, setTermsMain] = useState(false);
  const [clinicConsent, setClinicConsent] = useState(false);
  const [clinicPolitica, setClinicPolitica] = useState(false);
  const [clinicEnquadramento, setClinicEnquadramento] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [bypassPermissions, setBypassPermissions] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [upcomingEmpty, setUpcomingEmpty] = useState(false);
  const [isLoadingUpcoming, setIsLoadingUpcoming] = useState(false);
  const [appointmentsUpcoming, setAppointmentsUpcoming]: any = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loaded, setLoaded] = useState(false);

  // NOTE: This state is used to fix a bug with navigation where in some cases, a user could not go to the Homepage and would always be redirected to Schedule Appointment
  const [
    shouldNavigateToAppointmentSchedule,
    setShouldNavigateToAppointmentSchedule,
  ] = useState(false);

  const isNotClient = selectedBu.buId === Bu.notClient;
  const clientMemId = isNotClient ? user.nif : selectedBu.memId;

  const featureName = 'AppointmentsHistory';

  const checkConsents = !oneTrustIsVisible
    ? true
    : (labelsOneTrust?.porpose_clinic_terms_main_show === 'true'
        ? termsMain
        : true) &&
      (labelsOneTrust?.porpose_clinic_consentimento_show === 'true'
        ? clinicConsent
        : true) &&
      (labelsOneTrust?.porpose_clinic_politica_show === 'true'
        ? clinicPolitica
        : true) &&
      (labelsOneTrust?.porpose_clinic_enquadramento_show === 'true'
        ? clinicEnquadramento
        : true);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }
  const getAppointmentsUpcoming = async (loading: boolean) => {
    try {
      setIsLoadingUpcoming(loading);
      await get(
        uriGetAppointmentsUpcoming(selectedBu.buId, clientMemId),
        false,
        0,
        featureName,
      ).then((res: any) => {
        res.data?.items?.length === 0
          ? setUpcomingEmpty(true)
          : setAppointmentsUpcoming(res.data?.items);
      });
    } catch (err) {
      setUpcomingEmpty(true);
    } finally {
      setIsLoadingUpcoming(false);
    }
  };
  const getPurposes = async () => {
    try {
      await get(uriGetUserConsents(user.nif), false, 0, featureName).then(
        (res: any) => {
          const termsMainData = res?.data?.items[0].purposes.find(
            (element: any) =>
              element.id === labelsOneTrust?.porpose_clinic_terms_main,
          );
          if (
            termsMainData &&
            termsMainData.version ===
              parseInt(labelsOneTrust?.version_porpose_terms_main) &&
            termsMainData.status === 'ACTIVE'
          ) {
            setTermsMain(true);
            res?.data?.items[0].purposes.forEach((element: any) => {
              if (element.id === labelsOneTrust?.porpose_clinic_consentimento) {
                setClinicConsent(element.status === 'ACTIVE');
              } else if (
                element.id === labelsOneTrust?.porpose_clinic_politica
              ) {
                setClinicPolitica(element.status === 'ACTIVE');
              } else if (
                element.id === labelsOneTrust?.porpose_clinic_enquadramento
              ) {
                setClinicEnquadramento(element.status === 'ACTIVE');
              }
            });
          }
        },
      );
      setLoaded(true);
    } catch (e: any) {
      setShowPermissionsModal(true);
    }
  };

  const getPatientList = async () => {
    try {
      await get(
        uriUserBuOnlineOnly(user.nif, user.birthdate, true),
        false,
        0,
        featureName,
      ).then((res: any) => {
        if (res) {
          setPatientList(res?.data?.products);
          setPatientListSet(true);
        }
      });
    } catch {
      setShowError(true);
    }
  };

  const handleOnScheduleAppointmentClick = () => {
    if (loaded && !(checkConsents || bypassPermissions)) {
      setShowPermissionsModal(true);
    }
    setShouldNavigateToAppointmentSchedule(true);
    if (user.state === 'NOTCLIENT' || user.state === 'NOT_FOUND') {
      setPatientList([
        {
          buId: '',
          name: user.name,
        },
      ]);
      setPatientListSet(true);
    } else {
      getPatientList();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  useEffect(() => {
    if (shouldNavigateToAppointmentSchedule && (!oneTrustIsVisible || loaded)) {
      setLoaded(false);
      setShouldNavigateToAppointmentSchedule(false);
      if (checkConsents || bypassPermissions) {
        if (patientList.length > 0) {
          history.push({
            pathname: '/consultas-online/marcar-consulta',
            state: {
              patientList: patientList,
              editingAppointmentId: undefined,
            },
          });
        } else {
          setShowGeneralError(true);
        }
      } else {
        setShowPermissionsModal(true);
      }
    }
    setBypassPermissions(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, shouldNavigateToAppointmentSchedule]);

  useEffect(() => {
    if (patientListSet) {
      setPatientListSet(false);
      if (
        patientList.length === 1 ||
        user.state === 'NOTCLIENT' ||
        user.state === 'NOT_FOUND'
      ) {
        if (
          upcomingEmpty ||
          appointmentsUpcoming.length <
            appointmentsLabels?.appointments_schedule_upcoming_limit_default
        ) {
          oneTrustIsVisible && getPurposes();
        } else {
          setShowError(true);
        }
      } else {
        oneTrustIsVisible && getPurposes();
      }
    }
  }, [patientListSet]);

  useEffect(() => {
    setUpcomingEmpty(false);
    getAppointmentsUpcoming(true);
    setRefresh(false);
  }, [selectedBu.memId]);

  useEffect(() => {
    if (refresh) {
      setUpcomingEmpty(false);
      getAppointmentsUpcoming(true);
      setRefresh(false);
    }
  }, [refresh]);

  const history = useHistory();
  const bubbleImage = `${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${medicoOnline?.image}`;

  return (
    <Row className="services-container medico-online-container">
      {windowWidth > 768 ? (
        <>
          {medicoOnline && !medicoOnlineDisabled && visible && (
            <>
              <Column>
                <Row className="services-row-images-container">
                  <Column className="medico-online-column-images-container">
                    <Row className="services-row-images-display">
                      <BubbleMedicoOnline
                        classNames={'medico-online-bubble-image'}
                        height={'300px'}
                        width={'300px'}
                      />
                      <AuthorizedImage
                        source={bubbleImage}
                        className="medico-online-image"
                      />
                    </Row>
                  </Column>
                </Row>
              </Column>
              <Column className="medico-online-titlecolumn">
                <Row
                  className="medico-online-heading1"
                  style={{...fonts.XL, ...fonts.Bold}}>
                  {medicoOnline?.serviceName}
                </Row>
                <Row
                  className="medico-online-subtitle"
                  style={{...fonts.Bold, color: colors.black}}>
                  {medicoOnline?.subTitle}
                </Row>
                <Row
                  className="medico-online-description"
                  style={{...fonts.MM, ...fonts.Medium, color: colors.black}}>
                  {medicoOnline?.listDescription}
                </Row>
                <Row>
                  <AppButton
                    variant="primary"
                    className="medico-online-button"
                    disabled={isLoadingUpcoming}
                    onClick={handleOnScheduleAppointmentClick}>
                    {medicoOnline?.buttonText}
                  </AppButton>
                </Row>
              </Column>
            </>
          )}
        </>
      ) : (
        <>
          {medicoOnline && !medicoOnlineDisabled && visible && (
            <Column>
              <Row className="medico-online-image-responsive-container">
                <Row className="services-row-images-container">
                  {medicoOnline && (
                    <Column className="medico-online-column-images-container">
                      <Row className="services-row-images-display">
                        <BubbleMedicoOnline
                          classNames={'medico-online-bubble-image'}
                          height={'280px'}
                          width={'280px'}
                        />
                        <AuthorizedImage
                          source={bubbleImage}
                          className="medico-online-image"
                        />
                      </Row>
                    </Column>
                  )}
                </Row>
              </Row>
              <Row className="medico-online-heading1" style={{...fonts.Bold}}>
                {medicoOnline?.serviceName}
              </Row>
              <Row
                className="medico-online-subtitle"
                style={{...fonts.S, ...fonts.Medium, color: colors.black}}>
                {medicoOnline?.subTitle}
              </Row>
              <Row
                className="medico-online-description"
                style={{...fonts.MM, color: colors.black}}>
                {medicoOnline?.listDescription}
              </Row>
              <Row className="medico-online-button-row">
                <AppButton
                  variant="primary"
                  className="medico-online-button"
                  onClick={() => history.push('/consultas-online')}>
                  {medicoOnline?.buttonText}
                </AppButton>
              </Row>
            </Column>
          )}
        </>
      )}
      <ModalTemplate
        className="appointment-cancel-container"
        contentClassName="appointment-cancel-content"
        show={showGeneralError}
        onHide={() => {
          setShowGeneralError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox={false}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {showGeneralError && appointmentsLabels?.appointments_error}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setShowGeneralError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
      <AppointmentsScheduleCapPopup
        show={showError}
        setShowModal={setShowError}
      />
      <AppointmentsPermissions
        show={showPermissionsModal}
        setShowModal={setShowPermissionsModal}
        setBypassPermissions={setBypassPermissions}
        patientList={patientList}
      />
    </Row>
  );
}

const mapStateToProps = ({
  user,
  selectedBu,
  strings,
  stringsDefault,
  wizard,
  globalStyles,
  busFuncMapDefault,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.services,
  appointmentsLabels: strings.value.pt.appointments,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  busFuncMapDefault: busFuncMapDefault.value,
  labelsOneTrust: stringsDefault.value.pt.oneTrust,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MedicoOnline),
);
